// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2IUsE","inner":"Footer_inner__3o5F-","nextIcon":"Footer_nextIcon__21QQk","innerLeft":"Footer_innerLeft__3JVpJ"};